module.exports = __webpack_public_path__ + "img/checkout-summary.9cb58f8d.png";